import {Component, Input} from '@angular/core';
import {QuestListItem} from "../../../interfaces/quest-list-item";
import {QuestState} from "../../../enums/quest-state";
import {TrophyData} from "../../../interfaces/trophy-data";
import {GameTrophyStatus} from "../../../enums/game-trophy-status";

const QUEST_BADGE_PATH = "/assets/img/quest-badges/badge-single-quest-";
// Shown when there is no badge asset yet for a task's point value
const QUEST_BADGE_FALLBACK_POINTS = 1250;

@Component({
  selector: 'brt-quest-list-item',
  templateUrl: './quest-list-item.component.html',
  styleUrls: ['./quest-list-item.component.scss']
})
export class QuestListItemComponent {
  @Input('data') set setData(val: QuestListItem) {
    this.trophyIcon = {
      id: val.trophyId,
      description: "",
      status: GameTrophyStatus.NORMAL,
      name: ""
    }
    this.data = val;

    this.badgeFallbackUsed = false;
    this.badgeSrc = val.state === QuestState.DONE && val.points && val.points > 0
      ? `${QUEST_BADGE_PATH}${val.points}.svg`
      : null;
  }

  trophyIcon!: TrophyData;

  data!: QuestListItem;
  badgeSrc: string | null = null;
  private badgeFallbackUsed = false;
  protected readonly QuestState = QuestState;

  tagClickCallback(onClickCallback: ((...args: any[]) => any) | undefined) {
    if(onClickCallback) {
      onClickCallback();
    }
  }

  onBadgeError() {
    if(this.badgeFallbackUsed) {
      this.badgeSrc = null;
      return;
    }

    this.badgeFallbackUsed = true;
    this.badgeSrc = `${QUEST_BADGE_PATH}${QUEST_BADGE_FALLBACK_POINTS}.svg`;
  }
}
